import { render } from "./whats-app-preview.vue?vue&type=template&id=aa64c946&scoped=true"
import script from "./whats-app-preview.vue?vue&type=script&lang=js"
export * from "./whats-app-preview.vue?vue&type=script&lang=js"

import "./whats-app-preview.vue?vue&type=style&index=0&id=aa64c946&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa64c946"]])

export default __exports__